import {createSlice} from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/objectsData/ObjectsDataUIHelpers";

const initialObjectsDataState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  objectDataForEdit: undefined,
  lastError: null,
  type: null,
  hasSearchKey: false,
  queryParams: initialFilter,
  valueCaption: "",
  isOpenControlErrorsPopUp: false,
  controlErrors: [],
  objectDataBasicInfo: undefined,
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const objectsDataSlice = createSlice({
  name: "objectsData",
  initialState: initialObjectsDataState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getObjectDataById
    objectDataFetched: (state, action) => {
      state.actionsLoading = false;
      state.objectDataForEdit = action.payload.objectDataForEdit;
      state.error = null;
    },
    // findObjectsData
    objectsDataFetched: (state, action) => {
      const { totalCount, entities, type, valueCaption, hasSearchKey, pageNumber, pageSize} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.objectDataForEdit = null;
      state.type = type;
      state.valueCaption = valueCaption;
      state.hasSearchKey = hasSearchKey;
      state.queryParams.pageSize = pageSize;
      state.queryParams.pageNumber = pageNumber;
    },
    // deleteObjectData
    objectDataDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateType: (state, action) => {
      state.queryParams.typeId = action.payload.typeId;
    },
    closeControlErrorsPopUp: (state, action) => {
      state.isOpenControlErrorsPopUp = false;
      state.controlErrors = [];
      state.objectDataBasicInfo = undefined;
    },
    openControlErrorsPopUp: (state, action) => {
      state.isOpenControlErrorsPopUp = true;
      state.controlErrors = action.payload.controlErrors.map((x,index) => {
        return {...x, id: index}
      });
    },
    setObjectDataBasicInfo: (state, action) => {
      state.objectDataBasicInfo  = action.payload.objectDataBasicInfo
    },
  }
});
